import React, { useState, useEffect } from "react";
import {
  Card,
  Col,
  Row,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import { getDoctorById, updateDoctor } from "services/V2_APIs/DoctorsConsultationApis/doctorsInfo.service";
import Spinner from "components/spinner";

const DoctorStatusBar = ({ toggle, modal, reload, currentDoctor }) => {
  const [selectedStatus, setSelectedStatus] = useState({});
  console.log(selectedStatus,"selectedStatus")
  // const [statusInfo, setStatsInfo] = useState({
  //   verificationStatus: "",
  // });
  const [loading, setLoading] = useState(true);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const statusType = [
    { label: "Approved", value: "Approved" },
    { label: "Pending", value: "Pending" },
    { label: "Rejected", value: "Rejected" },
  ];

  useEffect(() => {
    if (currentDoctor) {
      getCurrentDoctor();
    }
  }, [currentDoctor]);

  const getCurrentDoctor = () => {
    getDoctorById(currentDoctor?._id)
      .then(res => {
        if (res?.data) {
         console.log(res,"rress")
          // setStatsInfo({ ...statusInfo, verificationStatus });
          setSelectedStatus({
            label: res?.data[0]?.verificationStatus,
            value: res?.data[0]?.verificationStatus,
          });
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const handleSelectStatus = event => {
    setSelectedStatus(event);
  };

  const save = () => {
    let obj = {
      ...currentDoctor,
      verificationStatus: selectedStatus?.value,
    };
    handleSubmit(obj);
  };

  const handleSubmit = body => {
    setLoading(true);
    updateDoctor(body, currentDoctor?._id)
      .then(res => {
        setsuccess_msg(true);
        setLoading(false);
        reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const leaveToList = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    toggle();
  };

  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
  };

  const successPopup = () => {
    return (
      <SweetAlert
        title="Success"
        success
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        Status Updated Successfully
      </SweetAlert>
    );
  };

  const errorPopup = () => {
    return (
      <SweetAlert
        title="Failure"
        danger
        onConfirm={leaveToList}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Leave
            </Button>
            <Button
              color="danger"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              Continue
            </Button>
          </React.Fragment>
        }
      >
        Something went wrong
      </SweetAlert>
    );
  };

  return (
    <>
      {/* <Spinner loading={loading}/> */}
      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>Doctor Status</ModalHeader>
        <ModalBody>
          <Row className="mt-1">
            <Col md={12}>
              <Select
                name="status"
                id="statusType"
                value={selectedStatus}
                onChange={handleSelectStatus}
                options={statusType}
                classNamePrefix={"select2-selection "}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            className="w-md btn-sm me-2"
            onClick={leaveToList}
          >
            Cancel
          </Button>
          <Button color="primary" className="w-md btn-sm me-2" onClick={save}>
            Submit
          </Button>
        </ModalFooter>
      </Modal>
      {success_msg ? successPopup() : null}
      {error_msg ? errorPopup() : null}
    </>
  );
};

export default DoctorStatusBar;
